import { IQueryContext } from 'framework/context/IQueryContext';
import { IPurchaseUblBuffer, IPurchasesUblBufferQueryParams, IQueryResult } from 'gen/ApiClient';
import React from 'react';

export const PurchasesUblBufferQueryContext = React.createContext<IQueryContext<IQueryResult<IPurchaseUblBuffer>, IPurchasesUblBufferQueryParams>>(
	undefined as any
);
